export type LayoutMode =
  | 'flex-layout-mode'
  | 'snake-layout-mode'
  | 'sequence-layout-mode';

export const DEFAULT_LAYOUT_MODE: LayoutMode = 'sequence-layout-mode';
export const HAS_CONTENT_LAYOUT_MODE: LayoutMode = 'flex-layout-mode';
